import { HttpErrorResponse } from "@angular/common/http";
import { LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";

export interface WrittenAssignmentRecordState {
  loading: boolean;
  error: HttpErrorResponse;
  result: LearnerLearningRecord[];
}

export const initialWrittenAssignmentRecordState: WrittenAssignmentRecordState = {
  loading: false,
  error: null,
  result: []
}